import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

class PrestationsProduits {
	constructor() {
		let cache = {};

		let initFunc = () => {
			initCache();
			if (!cache.section || cache.slides.length <= 1) return;
			if (window.innerWidth > 991) {
				initScrollTrigger();
			}
		};

		let initCache = () => {
			cache.section = document.querySelector('.prestations-produits');
			cache.slidesContainer = document.querySelector('.prestations-produits__slides');
			cache.slides = document.querySelectorAll('.prestations-produits__slide');
		};

		let initScrollTrigger = () => {
			let slidesCount = cache.slides.length;
			let slideHeight = cache.section.offsetHeight;

			let tl = gsap.timeline({
				scrollTrigger: {
					trigger: cache.section,
					start: 'top top',
					end: '+=' + (slidesCount - 1) * slideHeight,
					pin: true,
					scrub: true,
					snap: {
						snapTo: 1 / (slidesCount - 1),
						duration: 0.3,
						ease: 'power1.inOut',
					},
				}
			});

			tl.to(cache.slidesContainer, {
				y: -(slidesCount - 1) * slideHeight,
				ease: 'none',
			});
		};

		initFunc();
	}
}

export { PrestationsProduits };
